var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _vm._m(0),
    _c("div", { staticClass: "col-12 col-md" }, [
      _c("span", { staticClass: "data-name" }, [_vm._v(" Área: ")]),
      _c("p", { staticClass: "font-16" }, [
        _vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.area?.name)) + " ")
      ])
    ]),
    _c("div", { staticClass: "col-12 col-md" }, [
      _c("span", { staticClass: "data-name" }, [
        _vm._v(" Fecha de Ultima Actualización: ")
      ]),
      _c("p", { staticClass: "font-16" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm._f("date")(_vm.value.updatedDate ?? _vm.value.createdDate)
            ) +
            " "
        )
      ])
    ]),
    _c("div", { staticClass: "col-12 col-md" }, [
      _c("span", { staticClass: "data-name" }, [_vm._v(" Usuario: ")]),
      _c("p", { staticClass: "font-16" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm._f("empty")(_vm.value.updatedBy ?? _vm.value.createdBy)
            ) +
            " "
        )
      ])
    ]),
    _c("div", { staticClass: "col-12" }, [
      _c("span", { staticClass: "data-name" }, [
        _vm._v(" Servicio a Ofrecer: ")
      ]),
      _c("p", { staticClass: "font-16" }, [
        _vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.service?.name)) + " ")
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Información Adicional")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }